/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Event instance manager
//
// Handles adding/deleting of instances from the in-memory list.
//
// Expects each item to be in an element with data-instance=true and data-date=start_date
//
// Inside, a click on something with data-action="remove-instance" will remove the instance
// and the associated element
//
// The form used for adding instances is the add_form option.
//   A data-action="add-instance" inside will add an instance
//   Will use data-instance to determine what type of data it is,
//     "start-date" "start-time" or "end-time"
//   Recurrence is supported with
//     "recurrence-ends" "recurrence-type" and "recurrency-day"
//
//   Recurrence types are 'daily', 'weekly', 'monthly'
//   Recurrence days is 0-6 for days of week (can be multiple)
//
//   The other instances should be date inputs
//
// Events will be triggered on the instance container when an instance is added
// or deleted.  The extra parameter for each event is a hash with start_date, start_time,
// end_time.
//   slzr:instance:add => Triggered when an instance is added
//   slzr:instance:remove => Triggered when an instance is removed

import _ from 'underscore';
import moment from 'moment';
import { EventEmitter } from '../event_emitter';
import * as DateUtils from '../date_utils';

const _sameDate = DateUtils.sameDate;
const _sameTime = DateUtils.sameTime;

// Event Instance model
//
// This class contains the list of event instances associated with an event, as well as
// methods for manipulating the list items.
//
// Additionally, this class can hold input field state. This should be in the same format
// as the +options+ parameter to +addRecurring+. See +getInputFields+ and +setInputFields+.
//
// This class also provides support for basic limitations on number of instances and the
// number of instances added with one recurrence entry.
//
// Instances are keyed by their start date and start time.
//
// Instances of this class are EventEmitters, with the following events:
//   slzr:instance:add => Triggered when an instance is added
//   slzr:instance:change => Triggered when the start/end time of an instance is changed
//   slzr:instance:remove => Triggered when an instance is removed
//   slzr:fields:changed => Triggered when the instance field data is changed
export class EventInstances extends EventEmitter {
        static initClass() {
          this.LockReason =
            {'has_tickets': 'has_tickets'};
  
          // Internal instances store
          //
          // Array of objects: {start_date:, start_time:, end_time:, lock_reason:, id:, rooms_reservation:}
          this.prototype.instances = [];
          // default input field options
          this.prototype.default_field_values = {
            // The date/time input fields, in both their parsed and raw ("_input") values
            start_date: null,
            start_date_input: null,
            end_time: null,
            end_time_input: null,
            start_time: null,
            start_time_input: null,
            recurrence_end_date: null,
            recurrence_end_date_input: null,
  
            // Additional input fields that are not "parsed" like date/time inputs
            //
            // These values should match the default state in InstanceManagerComponent
            repeat_type: 'once',
            interval: 1,
            weekdays: [0, 1, 2, 3, 4, 5, 6],
            limit: null,
            month_repeat_on: 'day_of_month',
            recurrence_end_type: 'date',
  
            // Indicator of a valid entry being input
            valid_entry: false
          };
        
          // Determine if *input_fields* changed
          this.prototype.is_dirty = false;
  
          this.prototype.default_options = {
            // Maximum number of instances to allow
            max_instances: 20,
  
            // Don't allow adding more than 300 instances at once (via recurring)
            add_limit: 300,
  
            // Initial instances
            //
            // Each element is [start_date, start_time, end_time], should be string values
            initial_instances: []
          };
        }

        constructor(options, initial_input_fields) {
          if (initial_input_fields == null) { initial_input_fields = {}; }
          super();
          this.getInputFields = this.getInputFields.bind(this);
          this.getIsDirty = this.getIsDirty.bind(this);
          this.setInputFields = this.setInputFields.bind(this);
          this.resetInputFields = this.resetInputFields.bind(this);
          this.getRecurrenceSettings = this.getRecurrenceSettings.bind(this);
          this.addInstancesFromInputFields = this.addInstancesFromInputFields.bind(this);
          this._addInitialInstances = this._addInitialInstances.bind(this);
          this.addRecurring = this.addRecurring.bind(this);
          this.add = this.add.bind(this);
          this.update = this.update.bind(this);
          this.remove = this.remove.bind(this);
          this.removeAtIndex = this.removeAtIndex.bind(this);
          this.count = this.count.bind(this);
          this.valid = this.valid.bind(this);
          this.firstInstanceAt = this.firstInstanceAt.bind(this);
          this.nextInstance = this.nextInstance.bind(this);
          this.nextInstanceAt = this.nextInstanceAt.bind(this);
          this.nextInstanceDuration = this.nextInstanceDuration.bind(this);
          this.nextInstanceDurationMinutes = this.nextInstanceDurationMinutes.bind(this);
          this.instanceDatesToString = this.instanceDatesToString.bind(this);
          this._instanceStartTime = this._instanceStartTime.bind(this);
          this._instanceEndTime = this._instanceEndTime.bind(this);
          this._combineDateAndTime = this._combineDateAndTime.bind(this);
        
          this.instances = [];
          this.options = _.extend({}, this.default_options, options);

          // # Input field options
          //
          // Do not access this directly; use +getInputFields+ and +setInputFields+.
          // Initial assignment comes from +@default_field_values*
          this.input_fields = _.extend({}, this.default_field_values, initial_input_fields);

          this._addInitialInstances();
        }

        // Retrieve the current input field state
        getInputFields() {
          return this.input_fields;
        }

        getIsDirty() {
          return this.is_dirty;
        }
        
        // Merge the input field state with the provided updates
        //
        // If silent is true, does not emit the slzr:fields:chagned event. This is only intended for use
        // when the instance manager is syncing its state to this object.
        setInputFields(updates, silent) {
          if (silent == null) { silent = false; }
          this.input_fields = _.extend({}, this.input_fields, updates);
          if (!silent) { this.emit('slzr:fields:changed', this.input_fields); }
          return this.is_dirty = true;
        }

        resetInputFields() {
          this.setInputFields(this.default_field_values);
          return this.is_dirty = false;
        }

        // Build recurrence settings from the input fields
        getRecurrenceSettings() {
          const result = {};

          let {
            weekdays
          } = this.input_fields;
          result.interval = this.input_fields.interval;

          switch (this.input_fields.repeat_type) {
            case 'once':
              result.type = 'once';
              weekdays = [0, 1, 2, 3, 4, 5, 6];
              break;
            case 'daily':
              result.type = 'daily';
              weekdays = [0, 1, 2, 3, 4, 5, 6];
              break;
            case 'weekly':
              result.type = 'weekly';
              break;
            case 'monthly':
              result.type = 'monthly';
              result.repeat_on = this.input_fields.month_repeat_on;
              weekdays = [0, 1, 2, 3, 4, 5, 6];
              break;
            case 'monthly_day_of_month':
              result.type = 'monthly';
              result.repeat_on = 'day_of_month';
              weekdays = [0, 1, 2, 3, 4, 5, 6];
              break;
            case 'monthly_day_of_week':
              result.type = 'monthly';
              result.repeat_on = 'day_of_week';
              weekdays = [0, 1, 2, 3, 4, 5, 6];
              break;
            case 'yearly':
              result.type = 'yearly';
              weekdays = [0, 1, 2, 3, 4, 5, 6];
              break;
            case 'weekdays':
              result.type = 'weekly';
              result.interval = 1;
              weekdays = [1, 2, 3, 4, 5];
              break;
            case 'weekdays_mwf':
              result.type = 'weekly';
              result.interval = 1;
              weekdays = [1, 3, 5];
              break;
            case 'weekdays_tth':
              result.type = 'weekly';
              result.interval = 1;
              weekdays = [2, 4];
              break;
          }

          result.weekdays = weekdays.sort();
          result.recurrence_end_type = this.input_fields.recurrence_end_type;
          result.recurrence_end_date = this.input_fields.recurrence_end_date;
          result.recurrence_end_count = this.input_fields.recurrence_end_count;

          result.start_date = this.input_fields.start_date;
          result.start_time = this.input_fields.start_time;
          result.end_time = this.input_fields.end_time;
          result.remove_future_instances = this.input_fields.repeat_type === 'once' ? false : this.input_fields.remove_future_instances;

          return result;
        }

        // Add a range of instances based on the input field state
        addInstancesFromInputFields() {
          if (this.input_fields.valid_entry && this.input_fields.start_date) {
            return this.addRecurring(this.getRecurrenceSettings());
          }
        }

        // Add the initial instances to the data
        _addInitialInstances() {
          return (() => {
            const result = [];
            for (const instance_data of Array.from(this.options.initial_instances)) {
              const [start_date, start_time, end_time, lock_reason, id, rooms_reservation] = instance_data;
              result.push(this.add(start_date, start_time, end_time, lock_reason, id, rooms_reservation));
            }
            return result;
          })();
        }

        // Add instances in a recurring range
        //
        // The options are:
        //   type: Recurrence type
        //         daily, weekly, monthly, yearly
        //   start_date: Start date of recurrance
        //   end_date: End date of recurrance range
        //   interval: Interval for skipping
        //   limit: Limit of count to create
        //   start_time: Start time of event instances
        //   end_time: End time of event instances
        //   weekdays: Weekday numbers [0..6]
        //   repeat_on: day_of_month, day_of_week
        //
        // The start_date, start_time, end_time arguments are expected to be strings (not dates)
        addRecurring(options) {
          let end_date; let limit;
          const {
            start_time
          } = options;
          const {
            end_time
          } = options;

          let {
            type
          } = options;
          if ((options.type === 'monthly') && (options.repeat_on === 'day_of_week')) { type = 'monthly_day'; }

          if (options.recurrence_end_type === 'date') {
            end_date = options.recurrence_end_date;
            limit = 1000;
          } else {
            // Need to specify an end date, so don't allow more than 10 years at once
            end_date = moment(options.start_date).add({years: 10});
            limit = options.recurrence_end_count;
          }

          const recurrence_options = {
            start_date: options.start_date,
            end_date,
            weekdays: options.weekdays,
            type,
            limit,
            interval: options.interval
          };

          // Remove any future instances to keep a clean slate
          if (options.remove_future_instances) {
            const save_end = moment();
            for (const instance of Array.from(this.instances)) {
              if (moment(instance.start_date).isAfter(save_end, 'day') && !instance.lock_reason) { this.remove(instance.start_date, instance.start_time); }
            }
          }

          this.is_dirty = false;
          const recurrence = new Slzr.Util.DateRecurrence(recurrence_options);
          return Array.from(recurrence.dates()).map((date) => this.add(date, start_time, end_time));
        }

        // Add an instance
        //
        // The values are expected to be strings
        //
        // Adding an instance with the same date will cause the existing instance's start and end times to be
        // updated to the passed values.
        //
        // If an instance is added with no time, but an instance already exists on that date, then it is ignored
        //
        // If start_date is passed in as a string, it's expected to be in ISO8601 format (YYYY-MM-DD).
        // If start_time and end_time are strings, they're expected to be in HH:MM:SS format.
        //
        // Returns true if the instance was added, false otherwise
        add(start_date, start_time, end_time, lock_reason = null, id = null, rooms_reservation = null) {
          if ((typeof(start_date) === 'string') && !start_date.isBlank()) { start_date = moment(start_date, 'YYYY-MM-DD').toDate(); }
          if ((typeof(start_time) === 'string') && !start_time.isBlank()) { start_time = moment(start_time, 'hh:mm:ss').toDate(); }
          if ((typeof(end_time) === 'string') && !end_time.isBlank()) { end_time = moment(end_time, 'hh:mm:ss').toDate(); }

          // If date not entered and there's only one instance, change the times
          if ((start_date == null) && (start_time != null) && (this.instances.length === 1)) {
            ({
              start_date
            } = this.instances[0]);
          } else if ((start_date == null)) {
            return false;
          }

          const data = {
            start_date,
            start_time,
            end_time,
            lock_reason
          };

          if (id != null) { data.id = id; }
          if (rooms_reservation != null) { data.rooms_reservation = rooms_reservation; }

          // Don't add an all-day instance on a date with an instance and start time
          if ((start_time === null) && (_.findIndex(this.instances, i => _sameDate(i.start_date, start_date) && (i.start_time !== null)) > -1)) {
            return true;
          }

          // Match against an instance with the same start date/time, or one without a start time.
          const index_of_instance = _.findIndex(this.instances, i => (_sameDate(i.start_date, start_date) && _sameTime(i.start_time, start_time)) ||
            (_sameDate(i.start_date, start_date) && ((i.start_time === '') || (i.start_time === null))));

          if (index_of_instance === -1) {
            // Add it
            this.instances.push(data);
            this.instances = this._cleanInstances(this.instances);
            this.emit('slzr:instance:add', data);
          } else {
            // Update
            const existing = this.instances[index_of_instance];
            if (!!existing.id && !data.id) { data.id = existing.id; }
            if (!!existing.rooms_reservation && !data.rooms_reservation) {
              data.rooms_reservation = existing.rooms_reservation;
            }
            if (!!existing.lock_reason && !data.lock_reason) { data.lock_reason = existing.lock_reason; }
            this.instances[index_of_instance] = data;
            this.instances = this._cleanInstances(this.instances);
            this.emit('slzr:instance:change', data);
          }

          return true;
        }

        // Update an instance, by index
        update(index, start_date, start_time, end_time) {
          let new_data;
          if ((typeof(start_date) === 'string') && !start_date.isBlank()) { start_date = new Date(`${start_date} 00:00:00`); }
          if ((typeof(start_time) === 'string') && !start_time.isBlank()) { start_time = new Date(start_time); }
          if ((typeof(end_time) === 'string') && !end_time.isBlank()) { end_time = new Date(end_time); }

          const existing = this.instances[index];

          this.instances[index] = (new_data = {
            start_date,
            start_time,
            end_time,
            lock_reason: existing?.lock_reason,
            id: existing?.id,
            rooms_reservation: existing?.rooms_reservation
          });

          this.instances = this._cleanInstances(this.instances);

          return this.emit('slzr:instance:change', new_data);
        }

        // Remove an instance
        //
        // If start_time is not specified, remove all instances on date, otherwise removes the instance
        // specified by start_date and start_time

        remove(start_date, start_time) {
          if (typeof(start_date) === 'string') { start_date = new Date(`${start_date} 00:00:00`); }

          // Remove any instances with a matching start date and time
          this.instances = _.sortBy(_.reject(this.instances, instance => _sameDate(instance.start_date, start_date) && (start_time ? _sameTime(instance.start_time, start_time) : true)), 'start_date');

          this.emit('slzr:instance:remove', {start_date});
          return true;
        }

        // Remove an instance at the specified index
        removeAtIndex(index) {
          const instance = this.instances[index];
          this.instances.splice(index, 1);

          this.emit('slzr:instance:remove', instance);
          return true;
        }

        // Return the number of instances currently set
        count() { return this.instances.length; }

        // Returns true if there's any instances set
        valid() { return this.instances.length > 0; }

        // Return the earliest instance in the schedule as a date
        firstInstanceAt() {
          const instance = this.instances[0];

          if (instance != null) {
            return this._instanceStartTime(instance);
          } 
            return null;
          
        }

        // Return the next instance in the schedule
        //
        // The next instance is the next occuring instance, or the most recent
        nextInstance(now = null) {
          now = moment(now);
          const that = this;
          let next_instance = _.find(this.instances, item => now.isSameOrBefore(that._instanceStartTime(item)));
          if (!next_instance) { next_instance = this.instances[this.instances.length - 1]; }
          return next_instance;
        }

        // Return the next instance as a start date
        nextInstanceAt() {
          const next_instance = this.nextInstance();

          if (next_instance) {
            return this._instanceStartTime(next_instance);
          } 
            return null;
          
        }

        // Return the next instance's duration, or null if no duration is specified
        nextInstanceDuration() {
          const next_instance = this.nextInstance();
          if (!next_instance || !next_instance.start_time || !next_instance.end_time) { return null; }

          const starts_at = this._instanceStartTime(next_instance);
          const ends_at = this._instanceEndTime(next_instance);

          return ends_at.diff(starts_at, 'seconds');
        }

        // Return the next instance's duration in minutes, or null if no duration is specified
        nextInstanceDurationMinutes() {
          const duration = this.nextInstanceDuration();
          if (duration) {
            return Math.floor(duration / 60);
          } 
            return null;
          
        }

        instanceDatesToString(instance) {
          const new_instance = {};

          for (const k in instance) {
            const v = instance[k];
            if (k === "start_date") {
              new_instance[k] = _.isEmpty(v) ? "" : moment(v).format("YYYY-MM-DD");
            } else if (_.contains(["start_time", "end_time"], k)) {
              new_instance[k] = _.isEmpty(v) ? "" : moment(v).format("HH:mm:ss");
            } else {
              new_instance[k] = v;
            }
          }
        
          return new_instance;
        }

        // Convert the instance data into an object representing the start time
        _instanceStartTime(instance) {
          return this._combineDateAndTime(instance.start_date, instance.start_time);
        }

        // Convert the instance data into a moment object representing the end time
        //
        // Returns null if the instance does not have an end time
        _instanceEndTime(instance) {
          if (instance.end_time) {
            const starts_at = this._instanceStartTime(instance);
            const ends_at = this._combineDateAndTime(instance.start_date, instance.end_time);
            if (ends_at.isBefore(starts_at)) { ends_at.add({days: 1}); }
            return ends_at;
          } 
            return null;
          
        }

        // Utility method: Combine the date and time data
        _combineDateAndTime(date, time) {
          const date_part = moment(date);
          const time_part = time ? moment(time) : date_part.startOf('day');
          return time_part.set({year: date_part.year(), month: date_part.month(), date: date_part.date()});
        }

        // Clean instances
        //
        // This removes duplicate [start_date, start_time] pairs.
        //
        // Finally, it sorts the instances by [start_date, start_time]
        _cleanInstances(instances) {

          // Sort
          let new_instances = _.sortBy(instances, instance => [instance.start_date.getTime(), instance.start_time ? instance.start_time.getTime() : 0]);

          // Remove duplicates
          new_instances = _.uniq(new_instances, true, instance => [instance.start_date.getTime(), instance.start_time ? instance.start_time.getTime() : 0].join(','));

          return new_instances;
        }
      }
EventInstances.initClass();

